import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import Layers from "slotworks/graphics/layers/layers";
import Components from "slotworks/components/components";
import { ShowFreespinsElements } from "commands/freespins";
import rainbowStacksComponents from "components/components";
import { DisableUIButtons, HideUIButtons } from "commands/ui-buttons";
import CelebrateScatterCommand from "commands/celebrate-scatter-command";
import gameState from "slotworks/model/game-state";
import PromptContent from "slotworks/components/prompt/prompt-content";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import RainbowStacksSpinRecord from "integration/revolver/schema/spin-record";
import soundManager from "slotworks/sound/sound-manager";

export default class RainbowStacksEnterFreespins extends EnterFreespins {

    public onEnter() {
        DisableUIButtons();
        CelebrateScatterCommand().then(() => {
            super.onEnter();
        })
    }

    protected showPrompt() {
        Layers.SmartButton.hide();
        Layers.BetBar.hide();

        const record = gameState.getCurrentGame().getCurrentRecord() as RainbowStacksSpinRecord;

        const contents = new Map<string, string>();
        contents.set("value", record.freespinsWon.toString());

        const prompt = new PromptContent(["freespinswin"]);

        prompt.addText(contents);
        prompt.addContinueButton();

        const showFreespinsElements = () => {
            ShowFreespinsElements();
            HideUIButtons();

            if(record.grid) {
                for(let reel of record.grid) {
                    for(let index in reel) {
                        if(SYMBOLS_TO_CONVERT.indexOf(reel[index]) >= 0) {
                            reel[index] = reel[index] + "fs";
                        }
                    }
                }

                Components.matrix.jumpToGrid(record.grid);
                StaticSymbolsCommand().execute();
            }
        }

        Layers.CelebrationBackground.setScene("respins").execute();
        rainbowStacksComponents.prompt.showPrompt(prompt, null, showFreespinsElements).then(() => {
            Layers.CelebrationBackground.defaultScene().execute();
            setTimeout(() => this.complete(), 800);
        });
    }

    public complete() {
        soundManager.customEvent("freespins_music");
        Layers.SmartButton.show();
        Layers.BetBar.show();
        super.complete();
    }
}

const SYMBOLS_TO_CONVERT = [ "EE", "FF", "GG", "HH"];


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/enter-freespins.ts